import { kebabCase } from 'lodash'

import { Breadcrumb } from 'shared/types/Breadcrumb'

export const FOOTER_GRID_COLUMNS = 6

export const FOOTER_EMAIL_SIGNUP_COLUMNS = 2

export const FOOTER_LINK_COLUMNS = FOOTER_GRID_COLUMNS - FOOTER_EMAIL_SIGNUP_COLUMNS

export const FOOTER_GRID_COLUMN_GAP = '32px'

// TODO: This functionality is provisional until the footer can be fully authored in the CMS.
// Currently the code has to be aware of the CMS structure and slugs in order to comply with
// new requirements | BUY1-2042
export const getFooterLinkUrl = (
  parentBreadcrumb: Breadcrumb,
  linkBreadcrumb: Breadcrumb,
  isAuthenticated?: boolean,
) => {
  // in the CMS the footer section headers slugs start with 'footer/sectionLinks'
  const slugStart = 'footer/sectionLinks'
  const isSectionHeader = parentBreadcrumb.slug === linkBreadcrumb.slug

  if (linkBreadcrumb.urlOverride) return linkBreadcrumb.urlOverride

  if (isSectionHeader) {
    const sectionLink = linkBreadcrumb.slug.slice(slugStart.length + 1)
    return /http[s]?:/.test(sectionLink) ? sectionLink : `/${sectionLink}`
  } else {
    const relativeSlug = linkBreadcrumb.slug.replace(parentBreadcrumb.slug + '/', '/')

    if (/http[s]?:/.test(relativeSlug)) {
      return relativeSlug.slice(relativeSlug.indexOf('http'))
    }

    // the "Track My Order" link from the breadcrumbs needs to go to
    // the My Accounts page when logged in and there's no way to do that
    // via the breadcrumbs so we just override it here BUY1-287
    if (isAuthenticated && linkBreadcrumb.slug.indexOf('order-search')) {
      return linkBreadcrumb.slug
        .replace(parentBreadcrumb.slug + '/', '/')
        .replace('order-search', 'my-account')
    }

    return relativeSlug
  }
}

export const createSectionHeaderQaAttribute = (sectionName: string) =>
  `footer-section-header-${kebabCase(sectionName)}`
export const createSectionQaAttribute = (sectionName: string) =>
  `footer-section-${kebabCase(sectionName)}`
export const createLinkQaAttribute = (sectionName: string) =>
  `footer-section-${kebabCase(sectionName)}-link`
